type Props = {
  checked: boolean;
  onToggle: (next: boolean) => void;
  accent: string;
};

export function TermsLine({ checked, onToggle, accent }: Props) {
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        cursor: 'pointer',
        fontSize: 13,
        lineHeight: 1.5,
        color: 'rgba(14,14,14,.78)',
      }}
    >
      <span
        onClick={(e) => {
          e.preventDefault();
          onToggle(!checked);
        }}
        style={{
          width: 18,
          height: 18,
          flex: '0 0 18px',
          marginTop: 1,
          border: `1.5px solid ${checked ? accent : 'rgba(14,14,14,.45)'}`,
          background: checked ? accent : 'transparent',
          borderRadius: 4,
          display: 'inline-grid',
          placeItems: 'center',
          transition: 'all .15s',
        }}
      >
        {checked && (
          <svg width="11" height="11" viewBox="0 0 11 11" aria-hidden>
            <path
              d="M2 5.5 L4.5 8 L9 2.5"
              stroke="#fff"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
      <span>
        I agree to comply with the{' '}
        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          style={{ color: 'inherit', textDecoration: 'underline', textUnderlineOffset: 3 }}
        >
          Terms &amp; Conditions
        </a>{' '}
        and{' '}
        <a
          href="/terms#4-acceptable-use"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          style={{ color: 'inherit', textDecoration: 'underline', textUnderlineOffset: 3 }}
        >
          Acceptable Use Policy
        </a>
        .
      </span>
    </label>
  );
}
